// Node
import * as filter from 'lodash/filter';
import * as includes from 'lodash/includes';
import * as intersection from 'lodash/intersection';
import * as sortBy from 'lodash/sortBy';

import axios from 'axios';
import { union } from 'underscore';
import { filterNames } from '../camps_filter';
import {
  filtersToQuery,
  mergeCamps,
  parseUrl,
  priceSort,
  searchToObject,
  updateUrl,
  WITH_PET_TAG,
} from '../filter_utils';
import {
  addToFavorites,
  changeMapMarker,
  initializeFavorites,
  loadFavoriteCamps,
  removeFromFavorites,
} from '../new_design/common/favorite';
import SearchForm from '../new_design/common/search_widget/search_form/common';
const $ = require('jquery');
require('jquery.cookie');

const SANATORII_CATEGORY_ID = 6;
const PANSION_CATEGORY_ID = 7;
const BASE_CATEGORY_ID = 1;
const GLAMPING_CATEGORY_ID = 15;
const GUEST_HOUSE_CATEGORY_ID = 4;
const COTTAGE_CATEGORY_ID = 13;
const HOTEL_CATEGORY_ID = 8;
const FISHING_CATEGORY_ID = 2;
const HUNTING_CATEGORY_ID = 3;

const IS_MIRTURBAZ = window.website_type === '0';
const IS_SANATORIUMS = window.website_type === '1';
const IS_UBOOK = window.website_type === '2';
const DEFAULT_COUNT_GUESTS = 2;

export {
  BASE_CATEGORY_ID,
  COTTAGE_CATEGORY_ID,
  FISHING_CATEGORY_ID,
  GLAMPING_CATEGORY_ID,
  GUEST_HOUSE_CATEGORY_ID,
  HOTEL_CATEGORY_ID,
  HUNTING_CATEGORY_ID,
  IS_MIRTURBAZ,
  IS_SANATORIUMS,
  IS_UBOOK,
  PANSION_CATEGORY_ID,
  SANATORII_CATEGORY_ID,
};

const LOAD_MODE = {
  UI: 'ui',
  PREFETCH: 'prefetch',
};

const LOADING_ACTION = {
  LOAD_MORE: 'load_more',
  PRELOAD: 'preload',
};

// Предварительная загрузка страниц только для сортировок: Рекомендуемые, Отзывы
const PRELOAD_SORTS = ['recommendation', 'reviews'];

const MIN_PAGE_SIZE = 10;

export default class FilterMain extends React.Component {
  constructor(props) {
    super(props);
    window.ymReachGoal('filter');
    // Баз на странице
    this.pageSize = this.props.filter_params.page_size;
    this.maxFewerGuestsCount = 6;
    this.kottedzhi_category_id = 13;
    this.turbazi_category_id = 1;
    this.oteli_category_id = 8;
    this.sanatorii_category_id = 6;
    this.guest_house_category_id = 4;
    this.glemping_category_id = 15;
    this.blank = '';
    this.abortController = new AbortController();

    this.firstChunkPricesLoaded = false;

    this.pagination = {
      camps: {
        cache: new Map(),
        loadingPages: new Set(),
        pendingPage: null,
        loadedCount: 0,
      },
      nearby: {
        cache: new Map(),
        loadingPages: new Set(),
        pendingPage: null,
        loadedCount: 0,
      },
    };

    // Загрузка баз
    this.campsLoadingError = false;
    // Названия фильтров
    this.filterNames = filterNames();
    // Параметры карты
    this.mapOptions = {
      zoom: 8,
      controls: ['fullscreenControl', 'rulerControl', 'typeSelector', 'zoomControl'],
      fullScreen: true,
      bbox: this.props.filter_params.bbox,
    };
    // Предустановленные параметры фильтра
    let obj = this.props.filter_values || {};
    // Параметры поиска из урла
    const search_obj = searchToObject(window.location.search);
    this.seoMapOpened = obj.map_opened;
    // Парсим урл только если отсутствуют параметры виджета поиска
    if (intersection(Object.keys(search_obj), this.filterNames).length > 0) {
      obj = parseUrl();
    }

    // Сортировка
    this.descending = obj.isDescending ?? this.props.filter_values?.sort.descending;

    this.campId = obj.campId;
    this.numberOfCampsRequiredToShowFooterAds = 15;
    // Режим отображения: либо задан сеошаблоном, либо прописан в урле
    const showMode = !this.seoMapOpened && !window.location.hash.includes('#map_opened');
    const camps = this.props.camps ?? [];
    const lastPageLoaded = this.props.initial_camps_size === this.props.camps.length;

    this.state = {
      html_params: this.props.init_html_params || obj.html_params,
      map_html_params: {},
      campsOrigin: camps,
      camps: camps,
      mapCamp: camps.find((item) => item?.id === obj.campId),
      mapCampId: obj.campId,
      sight: this.props.sight,
      campsForMap: [],
      campsAdditional: [],
      skiLifts: [],
      pageNum: obj.page - 1 || 0,
      sort: obj.sortType ?? this.props.filter_values?.sort.type,
      listShowMode: showMode,
      campsLoadingMore: false,
      lastPageLoaded: lastPageLoaded,
      campsLoaded: this.props.camps.length > 0,
      mapCampsLoaded: false,
      showingInitialCamps: false,
      s_params: props.s_params,
      filters: {
        name: obj.name || '',
        categories: obj.categories?.map((n) => parseInt(n)) || false,
        all_categories: obj.all_categories?.map((n) => parseInt(n)) || false,
        prices: obj.prices || false,
        foodTypes: obj.foodTypes?.map((n) => parseInt(n)) || false,
        stars: obj.stars?.map((n) => parseInt(n)) || false,
        shoreDistance: obj.shoreDistance || false,
        distance: Array.isArray(obj.distance) && obj.distance?.length === 2 ? obj.distance?.map((n) => parseInt(n)) : [0, parseInt(obj.distance) || this.props.filter_params.max_distance],
        distanceToSkiLift: parseInt(obj.distanceToSkiLift),
        waters: obj.waters || false,
        campServiceTags: obj.campServiceTags || false,
        apartmentServiceTags: obj.apartmentServiceTags || false,
        campTreatmentProfiles: obj.campTreatmentProfiles || false,
        campLocations: obj.campLocations || false,
        campPromotions: obj.campPromotions || false,
        suitableTagsForRecovery: obj.suitableTagsForRecovery || false,
        campTreatmentFactors: obj.campTreatmentFactors || false,
        recovery: obj.recovery || false,
        tags_properties: obj.tags_properties?.map((n) => parseInt(n)) || false,
        swimming_pools_properties: obj.swimming_pools_properties?.map((n) => parseInt(n)) || false,
        districts: obj.districts?.map((n) => parseInt(n)) || false,
        bathTags: obj.bathTags?.map((n) => String(n)) || false,
        instant: obj.instant ?? this.props.filter_values?.instant,
        notRequiredPrepayment: obj.notRequiredPrepayment ?? this.props.filter_values?.not_required_prepayment,
        singleRoom: obj.singleRoom || false,
        discount: obj.discount || false,
      },
      datesChosen: false,
      initPrices: obj.prices || [],

      visibleFavoriteCamps: this.pageSize,
      filteredFavoriteCamps: this.props.camps,
      activeRegion: 0,
      favoriteCampsLoaded: false,
      favorites: initializeFavorites(this.props.camps),
      user_show_filter: false,
      loadError: false,
      // требование загрузить ОР с обновлёнными датами, как только закроется карта
      pendingLoadCamps: false,
      viewModeMap: !showMode,

      isInitialLoading: false,
      showListLoading: true,

      nearbyCamps: [],
      nearbyPageNum: 0,
      nearbyLastPageLoaded: false,
      nearbyLoading: false,
    };
    if (this.state.filters.categories[0] == this.kottedzhi_category_id && this.state.filters.categories.length === 1) {
      this.state.filters.categories = [this.kottedzhi_category_id, this.turbazi_category_id];
    }

    if (
      this.state.filters.categories[0] == this.guest_house_category_id &&
      this.state.filters.categories.length === 1
    ) {
      this.state.filters.categories = [];
    }

    if (this.state.filters.categories[0] == this.sanatorii_category_id && this.state.filters.categories.length === 1) {
      this.state.filters.categories = [];
    }

    if (this.state.filters.categories[0] == this.oteli_category_id && this.state.filters.categories.length === 1) {
      this.state.filters.categories = [];
    }

    // --- ДЛЯ ГЛЭМПИНГОВ ---
    if (this.state.filters.categories[0] == this.glemping_category_id && this.state.filters.categories.length === 1) {
      this.state.filters.categories = [];
    }

    this.bindFunctions = this.bindFunctions.bind(this);
    this.bindFunctions();
  }

  loadMore(type = 'camps') {
    const isNearby = type === 'nearby';

    const { cache, loadingPages } = this.pagination[type];

    const pageNum = isNearby ? this.state.nearbyPageNum : this.state.pageNum;

    const nextPage = pageNum + 1;

    const cached = cache.get(nextPage);

    if (cached) {
      this.applyCachedPage(nextPage, cached, type);
      return;
    }

    if (loadingPages.has(nextPage)) {
      this.pagination[type].pendingPage = nextPage;

      this.setState(isNearby ? { nearbyLoading: true } : { campsLoadingMore: true });

      return;
    }

    if (isNearby) {
      this.loadNearbyCamps(nextPage);
    } else {
      this.setState({ campsLoadingMore: true });
      this.loadCamps(nextPage);
    }
  }

  componentDidMount() {
    let search_data = JSON.parse($.cookie('search_data') ?? '{}');
    if ((search_data.date_start && search_data.date_end) || this.props.camps.length == 0) {
      this.setState({
        camps: [],
        campsOrigin: [],
        mapCamp: null,
        showingInitialCamps: false,
        campsLoaded: false,
      });
    }
    SearchForm.getSearchData().then((s_params) => {
      this.setState({ s_params: s_params, datesChosen: !!s_params.date_start }, () => {
        if (
          (this.state.s_params.date_start && this.state.s_params.date_end) ||
          (search_data.date_start && search_data.date_end) ||
          this.props.camps.length == 0 ||
          this.isFavorites
        ) {
          this.setState({
            camps: [],
            campsOrigin: [],
            mapCamp: null,
            showingInitialCamps: false,
            campsLoaded: false,
          });

          if (this.state.listShowMode) {
            this.loadCamps(0);
          } else {
            this.setState({ pendingLoadCamps: true });
          }
        }
      });

      if (s_params.with_pet) {
        let newFilters = this.state.filters;
        if (!newFilters.campServiceTags) newFilters.campServiceTags = [];
        if (newFilters.campServiceTags.indexOf(WITH_PET_TAG) > -1) return;
        newFilters.campServiceTags.push(WITH_PET_TAG);
      }
    });
    this.loadFavorites();
  }

  fewerCountGuests() {
    return Math.min(this.maxFewerGuestsCount, Math.ceil(this.state.s_params?.count_guests / 2) || DEFAULT_COUNT_GUESTS);
  }

  async loadFavorites() {
    const favoriteCampIds = await loadFavoriteCamps();
    this.setState({ favorites: favoriteCampIds });
  }

  setDates(date_start, date_end, delta_days = undefined) {
    this.setState(
      (state) => {
        return {
          s_params: {
            ...state.s_params,
            date_start: date_start,
            date_end: date_end,
            ...(delta_days !== undefined && { delta_days }),
          },
          datesChosen: date_start !== null || date_end !== null,
        };
      },
      () => {
        if (!this.state.listShowMode) {
          this.setState({ pendingLoadCamps: true });
        } else {
          this.loadCamps(0);
        }

        updateUrl(
          this.state.filters,
          this.state.pageNum,
          this.state.listShowMode,
          this.state.s_params,
          this.state.sort,
          this.descending,
          this.seoMapOpened
        );
      }
    );
  }

  setGuests(count_guests, children_ages) {
    this.setState((state) => {
      return {
        s_params: {
          ...state.s_params,
          count_guests: count_guests,
          children_ages: children_ages,
        },
      };
    });
  }

  setWithPet(withPet, callback = () => {}) {
    this.setState((state) => {
      return {
        s_params: {
          ...state.s_params,
          with_pet: withPet,
        },
      };
    }, callback);
  }

  setCampTreatmentProfiles(campTreatmentProfiles) {
    this.setState((state) => {
      return {
        filters: {
          ...state.filters,
          campTreatmentProfiles: campTreatmentProfiles,
        },
      };
    });
  }

  loadCamps(pageNum = 0) {
    if (pageNum === 0) {
      this.setState({
        camps: [],
        campsOrigin: [],
        skiLifts: [],
        pageNum: 0,
        lastPageLoaded: false,
        campsLoaded: false,
        isInitialLoading: true,
        showListLoading: true,
        nearbyCamps: [],
        nearbyPageNum: 0,
        nearbyLastPageLoaded: false,
        nearbyLoading: false,
      });
      this.firstChunkPricesLoaded = false;

      Object.values(this.pagination).forEach((pagination) => {
        pagination.cache.clear();
        pagination.loadingPages.clear();
        pagination.pendingPage = null;
        pagination.loadedCount = 0;
      });
    } else {
      this.setState({
        campsLoadingMore: true,
      });
    }
    this.loadCampsAllChunks(pageNum);
  }

  loadCampsAllChunks(pageNum = 0) {
    this.abortController = new AbortController();
    const signal = this.abortController.signal;
    if (this.state.s_params.date_start) {
      this.servicesIsLoading = new Set(['mt', 'integrations']);
      if (this.state.sort === 'price') {
        if (pageNum < 1) {
          this.loadCampsChunk(
            pageNum,
            'mt',
            (data) => {
              this.loadCampsChunk(
                pageNum,
                'integrations',
                null,
                data?.camps?.map((c) => c.id),
                signal
              );
            },
            null,
            signal
          );
        } else {
          this.servicesIsLoading = new Set(['all']);
          this.loadCampsChunk(pageNum, 'all', null, null, signal);
        }
      } else {
        this.loadCampsChunk(pageNum, 'mt', null, null, signal);
        this.loadCampsChunk(pageNum, 'integrations', null, null, signal);
      }
    } else {
      this.servicesIsLoading = new Set(['all']);
      this.loadCampsChunk(pageNum, 'all', null, null, signal);
    }
  }

  loadCampsChunk(
    pageNum = 0,
    service,
    callback = null,
    loadCampsIds = null,
    signal,
    mode = LOAD_MODE.UI,
    loadNearbyCamps = false
  ) {
    let url = window.location.href.split(/[?#]/)[0];
    if (url.endsWith('/')) {
      url = url.substr(0, url.lastIndexOf('/'));
    }
    url += '.json';
    const { string } = filtersToQuery(
      this.state.filters,
      pageNum,
      this.state.listShowMode,
      this.state.s_params,
      this.state.sort,
      this.descending
    );
    let search_data = JSON.parse($.cookie('search_data') ?? '{}');
    search_data.date_start = this.state.s_params.date_start;
    search_data.date_end = this.state.s_params.date_end;
    search_data.count_guests = this.state.s_params.count_guests;
    search_data.children_ages = this.state.s_params.children_ages;
    search_data.with_pet = this.state.s_params.with_pet;

    const { campTreatmentProfiles } = this.state.filters;
    // Если из фильтров уже убрали лечение/заболевание, которое выбрано в виджете поиска
    if (
      search_data.camp_treatment_profiles &&
      !(Array.isArray(campTreatmentProfiles) && campTreatmentProfiles.includes(search_data.camp_treatment_profiles))
    ) {
      delete search_data.camp_treatment_profiles;
    }
    $.cookie('search_data', JSON.stringify(search_data), { path: '/', expires: 60 });
    url += '?';
    url += new URLSearchParams(search_data).toString();
    if (this.isFavorites) {
      const campIds = new URLSearchParams(window.location.search).get('camp_ids');
      if (campIds) url += `&camp_ids=${encodeURIComponent(campIds)}`;
    }
    url += `&${string}`;

    if (service === 'mt') {
      url += '&load_integrations=false';
    } else if (service === 'integrations') {
      url += '&load_mt=false';
    }

    if (loadCampsIds) {
      url += `&load_camps_ids=${loadCampsIds.join(',')}`;
    }

    if (loadNearbyCamps) {
      url += '&load_nearby_camps=true';
    }

    axios
      .get(url, {
        signal,
      })
      .then((data) => {
        data = data.data;
        if (mode === LOAD_MODE.PREFETCH) {
          callback?.(data);
          return;
        }
        callback?.(data);
        if (loadNearbyCamps) {
          this.nearbyLoadChunkFinisher(data, pageNum, service);
        } else {
          this.campsLoadChunkFinisher(data, pageNum, service);
        }
      })
      .catch((error) => {
        this.campsLoadHandleError(error);

        const paginationType = loadNearbyCamps ? 'nearby' : 'camps';
        this.pagination[paginationType].loadingPages.delete(pageNum);
      });
  }

  campsLoadHandleError(error) {
    console.error(error);
    if (error.code != 'ERR_CANCELED') {
      this.setState({
        showingInitialCamps: false,
        favoriteCampsLoaded: true,
        campsLoadingMore: false,
        campsLoaded: true,
        loadError: true,
      });
    }
  }

  campsLoadChunkFinisher(data, pageNum, service) {
    const pageSize = data.html_params.page_size;
    const pageNumByLoaded = pageSize != null ? pageNum + Math.max(Math.ceil(pageSize / 25) - 1, 0) : pageNum;

    let prevCampsLength = this.state.camps?.length;
    let prevShowingInitialCamps = this.state.showingInitialCamps;
    let wasOldCampsChanged = false;
    let postAction = null;
    let postActionPage = null;
    let currentLastPageLoaded = false;

    this.lastLoadedTime = new Date();

    this.setState(
      (state) => {
        let newCamps = data.camps;

        if (!this.isFavorites) {
          newCamps = newCamps.filter((c) => c.apartments?.some((a) => a.tariffs?.length > 0) || c.complex_placement);
        }

        const oldCampsIds = state.campsOrigin.map((c) => c.id);

        const { allChunksLoaded, campsLoaded, lastPageLoaded, showListLoading, action } = this.getLoadingState({
          state,
          data,
          pageNum,
          pageNumByLoaded,
          service,
          newCamps,
          oldCampsIds,
          pagination: this.pagination.camps,
        });

        currentLastPageLoaded = lastPageLoaded;

        postAction = action;
        postActionPage = pageNumByLoaded + 1;

        const { campsOrigin, changed } = this.prepareCamps({ state, newCamps, allChunksLoaded });

        wasOldCampsChanged = changed;

        const newHtmlParams = data.html_params;
        newHtmlParams.filters_counts ??= state.html_params?.filters_counts;

        return {
          camps: campsOrigin,
          campsOrigin,
          ...(pageNum > 0 ? {} : { html_params: newHtmlParams }),
          showingInitialCamps: false,
          campsLoaded,
          campsLoadingMore: !allChunksLoaded && pageNum > 0,
          lastPageLoaded,
          allChunksLoaded,
          pageNum: pageNumByLoaded,
          showListLoading,
          ...(this.isFavorites && allChunksLoaded && lastPageLoaded ? { favoriteCampsLoaded: true } : {}),
        };
      },
      () => {
        if (postAction === LOADING_ACTION.LOAD_MORE) {
          this.loadCamps(postActionPage);
          return;
        }

        if (postAction === LOADING_ACTION.PRELOAD && PRELOAD_SORTS.includes(this.state.sort)) {
          this.preloadNextPage(postActionPage);
        }

        if (this.props.filter_params.city_id && currentLastPageLoaded && this.state.nearbyCamps.length === 0) {
          this.loadNearbyCamps();
        }

        if (this.isFavorites) {
          this.sortFavoriteCamps();
        }

        window.popupFilterChanged = true;

        const allServicesLoaded = this.servicesIsLoading.size === 0;
        const diffTime = new Date() - this.lastLoadedTime;

        if (allServicesLoaded) {
          this.onInitialLoadingFinished?.();
        }

        if (
          prevCampsLength > 0 &&
          !prevShowingInitialCamps &&
          wasOldCampsChanged &&
          allServicesLoaded &&
          diffTime > 1000
        ) {
          $('.cards').removeClass('cards-fade-in');
          requestAnimationFrame(() => {
            $('.cards').addClass('cards-fade-in');
          });
        }
      }
    );
  }

  getLoadingState({ state, data, pageNum, pageNumByLoaded, service, newCamps, oldCampsIds, pagination }) {
    const pageSize = data.html_params.page_size;

    let allChunksLoaded = false;
    let campsLoaded = state.campsLoaded;
    let lastPageLoaded = false;
    let showListLoading = state.showListLoading;
    let action = null;

    pagination.loadedCount += newCamps.filter((c) => !oldCampsIds.includes(c.id)).length;
    this.servicesIsLoading.delete(service);

    if (this.servicesIsLoading.size === 0) {
      // Все пачки загружены
      allChunksLoaded = true;

      lastPageLoaded = pageSize == null || data.html_params.pages_count <= pageNumByLoaded + 1;

      if (!this.firstChunkPricesLoaded) {
        this.firstChunkPricesLoaded = true;
      }

      const loadedCount = pagination.loadedCount;

      if (loadedCount < MIN_PAGE_SIZE && !lastPageLoaded) {
        action = LOADING_ACTION.LOAD_MORE;

        if (pageNum === 0) {
          showListLoading = false;
          campsLoaded = true;
        } else {
          campsLoaded = state.campsLoaded;
        }
      } else {
        pagination.loadedCount = 0;
        campsLoaded = true;

        if (!lastPageLoaded) {
          action = LOADING_ACTION.PRELOAD;
        }

        if (pageNum === 0) {
          showListLoading = true;
        }
      }
    } else if (pageNum === 0) {
      showListLoading = false;
      campsLoaded = true;
    }

    return {
      allChunksLoaded,
      campsLoaded,
      lastPageLoaded,
      showListLoading,
      action,
    };
  }

  prepareCamps({ state, newCamps, allChunksLoaded }) {
    const totalGuestsCount =
      (this.state.s_params?.count_guests ?? 0) + (this.state.s_params?.children_ages?.length ?? 0);
    let { camps, changed } = mergeCamps(state.campsOrigin, newCamps, totalGuestsCount);
    let campsOrigin = camps;

    if (state.sort === 'price' && allChunksLoaded) {
      // Применяем сортировку только когда все пачки загружены
      let categories = [];
      if (!this.props.seo_template?.is_main || this.props.category?.main_website_type != window.website_type) {
        categories = this.props.filter_values.categories;
        if (!categories?.length) categories = this.props.category?.id ? [this.props.category.id] : [];
      }
      campsOrigin = priceSort(campsOrigin, this.descending, categories);
    }

    return {
      campsOrigin,
      changed,
    };
  }

  preloadNextPage(pageNum, type = 'camps') {
    const isNearby = type === 'nearby';

    const pagination = this.pagination[type];

    if (pagination.loadingPages.has(pageNum) || pagination.cache.has(pageNum)) {
      return;
    }

    pagination.loadingPages.add(pageNum);

    const signal = this.abortController.signal;
    const prefetched = {};

    this.loadCampsChunk(
      pageNum,
      'mt',
      (mtData) => {
        prefetched.mt = mtData;

        this.loadCampsChunk(
          pageNum,
          'integrations',
          (integrationData) => {
            prefetched.integrations = integrationData;

            pagination.cache.set(pageNum, prefetched);
            pagination.loadingPages.delete(pageNum);

            if (pagination.pendingPage === pageNum) {
              pagination.pendingPage = null;

              this.applyCachedPage(pageNum, prefetched, type);
            }
          },
          mtData?.camps?.map((c) => c.id),
          signal,
          LOAD_MODE.PREFETCH,
          isNearby
        );
      },
      null,
      signal,
      LOAD_MODE.PREFETCH,
      isNearby
    );
  }

  applyCachedPage(pageNum, cached, type = 'camps') {
    this.servicesIsLoading = new Set(['mt', 'integrations']);

    const finisher = type === 'nearby' ? this.nearbyLoadChunkFinisher : this.campsLoadChunkFinisher;

    finisher(cached.mt, pageNum, 'mt');
    finisher(cached.integrations, pageNum, 'integrations');

    this.pagination[type].cache.delete(pageNum);
  }

  distanceInteraction() {
    this.interactedDistance = true;
  }

  distanceToSkiLiftInteraction() {
    this.interactedDistanceToSkiLift = true;
  }

  cityCamps() {
    return filter(this.state.campsOrigin, (camp) => includes(this.props.filter_params.city_camps_ids, camp.id));
  }

  handlePopstate() {
    const obj = parseUrl();
    const state = {};

    if (obj.page != null && obj.page >= 0) {
      state.pageNum = obj.page - 1;
    }
    if (obj.listShowMode != null) {
      state.listShowMode = obj.listShowMode;
    }
    this.setState(state);
  }

  showMap(camp = null) {
    this.filtersBeforeMap = JSON.stringify(this.state.filters);
    // Сначала обновляем состояние, а ПОТОМ только обновляем урл
    this.setState(
      {
        listShowMode: false,
        pageNum: 0,
        mapCampId: camp?.id ?? this.state.mapCampId,
        mapCamp: camp ?? this.state.campsOrigin.find((item) => item?.id === this.state.mapCampId),
      },
      () => {
        history.pushState(
          { hash: 'map_opened' },
          document.title,
          window.location.pathname + window.location.search + '#map_opened'
        );

        if (window.isMobileDevice) {
          window.openedPopupsIdsStack.push('#map_opened');
        }
      }
    );
  }

  showList() {
    // Сначала обновляем состояние, а ПОТОМ только обновляем урл
    this.setState(
      {
        listShowMode: true,
        viewModeMap: false,
      },
      () => {
        updateUrl(
          this.state.filters,
          this.state.pageNum,
          this.state.listShowMode,
          this.state.s_params,
          this.state.sort,
          this.descending,
          this.seoMapOpened
        );
      }
    );
    if (this.filtersBeforeMap != JSON.stringify(this.state.filters)) {
      this.filter(this.state.filters);
    }
  }

  resetFilter() {
    let filters = { ...this.state.filters };

    for (let filter in filters) {
      filters[filter] = false;
    }

    filters.shoreDistance = 0;
    filters.prices = [0, this.priceMaxEnd()];
    filters.distance = [0, this.props.filter_params.default_distance || this.props.filter_params.max_distance];

    this.filter(filters);
  }

  loadAdditionalCamps(zoom, bounds) {
    if (this.state.campsAdditional.length > 0) return;
    fetch(`${window.website_prefix}/filter/camps_additional.json?includes_id=${this.state.mapCampId}`)
      .then((response) => {
        return response.json();
      })
      .then((data) => {
        data.mapCamp = data.campsAdditional.find((item) => item?.id === this.state.mapCampId);

        data.campsAdditional = data.campsAdditional.filter(
          (item) => this.state.campsOrigin.find((_item) => _item.id == item.id) == null
        );
        this.setState(data);
      });
  }

  filter(filters, callback) {
    const petTagWasRemoved =
      Array.isArray(this.state.filters.campServiceTags) &&
      this.state.filters.campServiceTags.includes(WITH_PET_TAG) &&
      !(Array.isArray(filters.campServiceTags) && filters.campServiceTags.includes(WITH_PET_TAG));

    const s_params = petTagWasRemoved ? { ...this.state.s_params, with_pet: false } : this.state.s_params;

    this.setState({ filters: { ...filters }, s_params });
    updateUrl(
      filters,
      this.state.pageNum,
      this.state.listShowMode,
      s_params,
      this.state.sort,
      this.descending,
      this.seoMapOpened
    );
    if (this.state.listShowMode) {
      this.setState({ pageNum: 0, lastPageLoaded: false, campsLoaded: false });
      if (window.loadCampsTimeout) {
        clearTimeout(window.loadCampsTimeout);
      }
      this.abortController.abort();
      window.loadCampsTimeout = setTimeout(() => {
        this.loadCamps(0);
      }, 500);
    }
  }

  sort(type, allowReverse = true) {
    // В обратном порядке
    this.setDescending(type, allowReverse);
    this.setState({
      sort: type,
      pageNum: 0,
      lastPageLoaded: false,
      campsLoaded: false,
    });
    if (window.loadCampsTimeout) {
      clearTimeout(window.loadCampsTimeout);
    }
    this.abortController.abort();
    window.loadCampsTimeout = setTimeout(() => {
      this.loadCamps(0);
    }, 500);
  }

  mapProps() {
    return {
      camp: this.state.mapCamp,
      mapCampId: this.state.mapCampId,
      updateHtmlParams: (html_params) => this.setState({ map_html_params: html_params }),
      map_html_params: this.state.map_html_params,
      allCamps: union(this.state.campsOrigin, this.state.campsAdditional),
      sight: this.state.sight,
      skiLifts: this.state.skiLifts,
      loadAdditionalCamps: this.loadAdditionalCamps,
      mapOptions: this.mapOptions,
      showList: this.showList,
      s_params: this.state.s_params,
      filters: this.state.filters,
      longitude: this.props.filter_params.longitude,
      latitude: this.props.filter_params.latitude,
      icons: this.props.filter_params.icons,
      country_id: this.props.filter_params.country?.id,
      region_id: this.props.filter_params.region?.id,
      river_id: this.props.filter_params.river?.id,
      city_id: this.props.filter_params.city_id,
      htmlParams: window.location.search.split('?')[1],
      campsLoaded: this.state.campsLoaded && !this.state.showingInitialCamps,
      favorites: this.state.favorites,
      toggleFavoriteCamp: this.toggleFavoriteCamp,
      onChangeMapCampsLoaded: this.handleChangeMapCampsLoaded,
      totalGuestsCount: this.state.s_params?.count_guests ?? DEFAULT_COUNT_GUESTS,
      preventHistoryBack: this.state.viewModeMap,
    };
  }

  priceMaxEnd() {
    if (this.state.s_params?.delta_days) {
      return Math.min(30000 * (this.state.s_params?.delta_days || 1) * this.state.s_params?.count_guests, 500000);
    } else {
      return 500000;
    }
  }

  handleRegionChange(activeRegion) {
    let filteredFavoriteCamps = [];

    if (activeRegion === 0) {
      filteredFavoriteCamps = sortBy(this.state.camps, (camp) => !camp.apartments?.[0]?.calculated_price);
    } else {
      const selectedRegionName = this.props.regions[activeRegion - 1].name;
      filteredFavoriteCamps = this.state.camps.filter((camp) => camp.region_name === selectedRegionName);
      filteredFavoriteCamps = sortBy(filteredFavoriteCamps, (camp) => !camp.apartments?.[0]?.calculated_price);
    }

    this.setState({ activeRegion, filteredFavoriteCamps });
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }

  sortFavoriteCamps() {
    const sortedCamps = sortBy(this.state.camps, (camp) => !camp.apartments?.[0]?.calculated_price);
    return this.setState({ filteredFavoriteCamps: sortedCamps });
  }

  toggleFavoriteCamp(camp, favoriteBlock) {
    if (!favoriteBlock || favoriteBlock.length === 0) {
      favoriteBlock = $(`.card__favorite-block[data-camp-id='${camp.id}']`);
    }
    this.setState(
      (prevState) => {
        const isFavorite = prevState.favorites.includes(camp.id);

        if (isFavorite) {
          removeFromFavorites(camp.id, favoriteBlock);
          return { favorites: prevState.favorites.filter((id) => id !== camp.id) };
        } else {
          addToFavorites(camp.id, favoriteBlock);
          return { favorites: [...prevState.favorites, camp.id] };
        }
      },
      () => {
        const isFavorite = this.state.favorites.includes(camp.id);

        changeMapMarker(camp.id, !isFavorite, camp.is_can_instant_booking);
      }
    );
  }

  handleChangeMapCampsLoaded(mapCampsLoaded) {
    this.setState({ mapCampsLoaded });
  }

  /**
   * @param {(prevState: SearchParamsContextState) => void} callback
   */
  setSearchParams(callback) {
    this.setState((prevState) => ({
      ...prevState,
      s_params: callback(prevState.s_params),
    }));
  }

  componentDidUpdate(_, prevState) {
    // Загружаем новые ОР, если даты изменились с открытой картой И сейчас карта закрыта
    if (this.state.listShowMode && !prevState.listShowMode && this.state.pendingLoadCamps) {
      this.loadCamps(0);
      this.setState({ pendingLoadCamps: false });
    }
    if (prevState.filters !== this.state.filters) {
      this.setState({ pendingLoadCamps: true });
    }

    if (this.state.listShowMode) {
      $('body').removeClass('map-fullscreen-active');
    } else {
      $('body').addClass('map-fullscreen-active');
    }
  }

  loadNearbyCamps(pageNum = 0) {
    if (this.state.nearbyLoading) return;

    this.setState({ nearbyLoading: true });

    this.nearbyServicesIsLoading = new Set(['mt', 'integrations']);

    const signal = this.abortController.signal;

    this.loadCampsChunk(pageNum, 'mt', null, null, signal, LOAD_MODE.UI, true);
    this.loadCampsChunk(pageNum, 'integrations', null, null, signal, LOAD_MODE.UI, true);
  }

  nearbyLoadChunkFinisher(data, pageNum, service) {
    this.nearbyServicesIsLoading.delete(service);

    if (this.nearbyServicesIsLoading.size > 0) return;

    let postAction = null;
    let postActionPage = null;

    this.setState(
      (state) => {
        const oldCampsIds = state.nearbyCamps.map((c) => c.id);

        const { lastPageLoaded, action } = this.getLoadingState({
          state,
          data,
          pageNum,
          pageNumByLoaded: pageNum,
          service,
          newCamps: data.camps,
          oldCampsIds,
          pagination: this.pagination.nearby,
        });

        postAction = action;
        postActionPage = pageNum + 1;

        const camps = mergeCamps(
          state.nearbyCamps,
          data.camps,
          this.state.s_params?.count_guests || DEFAULT_COUNT_GUESTS
        ).camps;

        return {
          nearbyCamps: camps,
          nearbyPageNum: pageNum,
          nearbyLastPageLoaded: lastPageLoaded,
          nearbyLoading: false,
        };
      },
      () => {
        if (postAction === LOADING_ACTION.LOAD_MORE) {
          this.loadNearbyCamps(postActionPage);
          return;
        }

        if (postAction === LOADING_ACTION.PRELOAD && PRELOAD_SORTS.includes(this.state.sort)) {
          this.preloadNextPage(postActionPage, 'nearby');
        }
      }
    );
  }

  bindFunctions() {
    this.distanceInteraction = this.distanceInteraction.bind(this);
    this.distanceToSkiLiftInteraction = this.distanceToSkiLiftInteraction.bind(this);
    this.cityCamps = this.cityCamps.bind(this);
    this.handlePopstate = this.handlePopstate.bind(this);
    this.showMap = this.showMap.bind(this);
    this.showList = this.showList.bind(this);
    this.resetFilter = this.resetFilter.bind(this);
    this.loadAdditionalCamps = this.loadAdditionalCamps.bind(this);
    this.filter = this.filter.bind(this);
    this.sort = this.sort.bind(this);
    this.mapProps = this.mapProps.bind(this);
    this.loadCampsChunk = this.loadCampsChunk.bind(this);
    this.loadCamps = this.loadCamps.bind(this);
    this.setDates = this.setDates.bind(this);
    this.setGuests = this.setGuests.bind(this);
    this.setCampTreatmentProfiles = this.setCampTreatmentProfiles.bind(this);
    this.priceMaxEnd = this.priceMaxEnd.bind(this);
    this.setWithPet = this.setWithPet.bind(this);
    this.handleRegionChange = this.handleRegionChange.bind(this);
    this.sortFavoriteCamps = this.sortFavoriteCamps.bind(this);
    this.toggleFavoriteCamp = this.toggleFavoriteCamp.bind(this);
    this.fewerCountGuests = this.fewerCountGuests.bind(this);
    this.loadMore = this.loadMore.bind(this);
    this.campsLoadChunkFinisher = this.campsLoadChunkFinisher.bind(this);
    this.campsLoadHandleError = this.campsLoadHandleError.bind(this);
    this.loadCampsAllChunks = this.loadCampsAllChunks.bind(this);
    this.handleChangeMapCampsLoaded = this.handleChangeMapCampsLoaded.bind(this);
    this.getLoadingState = this.getLoadingState.bind(this);
    this.prepareCamps = this.prepareCamps.bind(this);
    this.preloadNextPage = this.preloadNextPage.bind(this);
    this.applyCachedPage = this.applyCachedPage.bind(this);
    this.setSearchParams = this.setSearchParams.bind(this);
    this.loadNearbyCamps = this.loadNearbyCamps.bind(this);
    this.nearbyLoadChunkFinisher = this.nearbyLoadChunkFinisher.bind(this);
  }
}
